import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { DecisionList } from './DecisionList';

export const DecisionListPage = () => {
  useTitle('Список решений');

  return (
    <Layout withFooter>
      <DecisionList />
    </Layout>
  );
};
